import script from "./ExamplePage.vue?vue&type=script&setup=true&lang=ts"
export * from "./ExamplePage.vue?vue&type=script&setup=true&lang=ts"

import "./ExamplePage.vue?vue&type=style&index=0&id=3f356172&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f356172"]])

export default __exports__